module.exports = __webpack_public_path__ + "64c0d7746e8111216c89f640c2a2b83b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/closetips.png
// module id = 456
// module chunks = 0